import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { HelpCircle } from "lucide-react";

let cache = null;
const loadHelp = () => { if (!cache) { cache = api.get("/help").then(({ data }) => data).catch(() => { cache = null; return {}; }); } return cache; };

export const ROUTE_HELP = [
  ["/owner/ordens/", null], ["/owner/ordens", "os"], ["/owner/nova-ordem", "os"], ["/owner/patio", "patio"], ["/owner/customers", "clientes"],
  ["/owner/estoque", "estoque"], ["/owner/compras", "compras"], ["/owner/fornecedores", "compras"], ["/owner/financeiro", "financeiro"],
  ["/owner/conciliar", "conciliacao"], ["/owner/notas", "fiscal"], ["/owner/dashboard", "relatorios"], ["/owner/rentabilidade", "relatorios"],
  ["/owner/equipe", "relatorios"], ["/owner/funcionarios", "equipe"], ["/owner/settings", "configuracoes"], ["/owner/meu-plano", "meu_plano"], ["/owner/importar", "importar"],
];

export function helpForRoute(path) {
  const hit = ROUTE_HELP.find(([p]) => (p.endsWith("/") ? path.startsWith(p) : path === p || path.startsWith(`${p}/`)));
  return hit ? hit[1] : null;
}

export function HelpTip({ screen, className = "" }) {
  const [h, setH] = useState(null);
  useEffect(() => { loadHelp().then((d) => setH(d[screen] || null)); }, [screen]);
  if (!h) { return null; }
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" data-testid={`help-${screen}`} aria-label={`Ajuda: ${h.title}`} className={`inline-flex h-8 w-8 items-center justify-center rounded-full border border-zinc-700 bg-zinc-900/80 text-zinc-300 hover:text-green-300 hover:border-green-700 transition-colors ${className}`}>
          <HelpCircle className="h-4 w-4" />
        </button>
      </PopoverTrigger>
      <PopoverContent data-testid={`help-${screen}-content`} align="end" className="w-72 bg-zinc-950 border-zinc-800 text-zinc-200">
        <div className="text-sm font-bold text-zinc-100 mb-1">{h.title}</div>
        <p className="text-sm text-zinc-300 leading-relaxed">{h.text}</p>
      </PopoverContent>
    </Popover>
  );
}
